import { capitalize, isNotEmpty } from 'utility/functions';

import { BroadcastEnum } from 'features/ippica/types';
import { DynamicImage, enLoading } from 'components/Image';
import { IppicaBroadcastBox } from '../ippicaBroadcast/ippicaBroadcastBox';
import { ScommesseTableWidget } from 'components/scommesseTable/scommesseTableWidget';
import { Widget } from 'features/sport/components/sportWidgetList/SportWidgetList';
import dynamic from 'next/dynamic';
import styles from './IppicaHeader.module.scss';
import { useTypedSelector } from 'lib/centralStore';

export type IppicaHeaderProps = {
  // nazione?: string;
  // descrizioneRiunione: string;
  widget?: Widget[];
  hasMarginRight?: boolean;
  containerClassName?: string;
  // image?: ImageProps & { srcFallback: string };
};
export const DynamicIppicaHeader = dynamic(() =>
  import('features/ippica/components/ippicaHeader').then((mod) => mod.IppicaHeader)
);
export const IppicaHeader = ({ widget, hasMarginRight, containerClassName }: IppicaHeaderProps) => {
  const { image, nazione, descrizioneRiunione, urlBroadcast, broadcastNeedsLogIn } = useTypedSelector(
    (state) => state.ippica.ippicaDetailRace!
  ) || {
    image: null,
    nazione: null,
    descrizioneRiunione: null,
  };

  const renderImage = () => {
    const { src, alt, title, srcFallback } = image ?? {};

    const imgSrc = src ?? srcFallback;

    if (isNotEmpty(imgSrc)) {
      return (
        <div className={styles.imageContainer}>
          <DynamicImage
            src={`${imgSrc}`}
            alt={alt ?? ''}
            title={title}
            fill
            loading={enLoading.lazy}
            decoding="async"
            className={styles.imageCountry}
          />
        </div>
      );
    }

    return <span className={styles.emptyImg}></span>;
  };

  return (
    <section
      className={`${styles.container} ${containerClassName ? containerClassName : ''} ${
        hasMarginRight ? styles.withMarginRight : ''
      }`}
    >
      <div className={styles.textContainer}>
        {renderImage()}
        <span className={styles.text}>{nazione}</span>
        {descrizioneRiunione && <h2 className={styles.title}>{capitalize(descrizioneRiunione) || '-'}</h2>}
      </div>
      {widget && widget.length > 0 && <ScommesseTableWidget items={widget} className={styles.widgetList} />}
      {urlBroadcast && (
        <IppicaBroadcastBox
          name={''}
          type={BroadcastEnum.TV}
          hasButtonOnIcon
          url={urlBroadcast}
          logged={broadcastNeedsLogIn}
        />
      )}
    </section>
  );
};
